/**
 * Select Component - Component Definition
 * =======================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { SelectController, SelectOptionController } from './controller';
import { SELECT_TEMPLATE } from './template';
import { SIZES, BASE_CLASSES, CHEVRON_ICON, DEFAULTS, SelectOption, SelectSize } from './constants';

export interface ISelectComponentBindings {
  label?: string;
  ariaLabel?: string;
  placeholder?: string;
  options?: SelectOption[];
  helpMessage?: string;
  error?: boolean;
  disabled?: boolean;
  size?: SelectSize;
  onChange?: (args: { value: string }) => void;
}

export const selectComponentDefinition: IComponentOptions = {
  template: SELECT_TEMPLATE,
  controller: SelectController,
  require: { ngModelCtrl: '?ngModel' },
  // Slots nombrados (label/help) + slot default (contenido no matcheado,
  // p. ej. <ec-select-option>) — ver template.ts para el outlet oculto.
  transclude: { labelSlot: '?ecLabel', helpSlot: '?ecHelp' },
  bindings: {
    label: '@',
    ariaLabel: '@',
    placeholder: '@',
    options: '<',
    helpMessage: '@',
    error: '<',
    disabled: '<',
    size: '@',
    onChange: '&?'
  }
};

/**
 * Definición del hijo de configuración `ecSelectOption` (compound).
 * `template: ''`: no renderiza nada visible, solo registra su data en el padre.
 */
export const selectOptionComponentDefinition: IComponentOptions = {
  template: '',
  controller: SelectOptionController,
  require: { select: '^?ecSelect' },
  bindings: {
    value: '@',
    label: '@',
    disabled: '<'
  }
};

export const MODULE_NAME = 'ec.select';

const selectModule: IModule = angular
  .module(MODULE_NAME, ['ngSanitize'])
  .component('ecSelect', selectComponentDefinition)
  .component('ecSelectOption', selectOptionComponentDefinition);

export { SelectController, SelectOptionController, SELECT_TEMPLATE, SIZES, BASE_CLASSES, CHEVRON_ICON, DEFAULTS };
export type { SelectOption, SelectSize } from './constants';
export default selectModule;
